"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Color_1 = __importDefault(require("../Color"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../AvatarContext"));
var HairColorName_1 = __importDefault(require("./HairColorName"));
function HairColor(_a) {
    var maskID = _a.maskID;
    var hairColor = react_1.useContext(AvatarContext_1.default).hairColor;
    return jsx_runtime_1.jsx(Color_1.default, { maskID: maskID, color: getHairColorCode(hairColor) }, void 0);
}
exports.default = HairColor;
function getHairColorCode(hairColor) {
    if (hairColor && hairColor.startsWith('#'))
        return hairColor;
    switch (hairColor) {
        case HairColorName_1.default.Auburn:
            return '#A55728';
        case HairColorName_1.default.Black:
            return '#2C1B18';
        case HairColorName_1.default.Blonde:
            return '#B58143';
        case HairColorName_1.default.BlondeGolden:
            return '#D6B370';
        case HairColorName_1.default.Brown:
            return '#724133';
        case HairColorName_1.default.PastelPink:
            return '#F59797';
        case HairColorName_1.default.Platinum:
            return '#ECDCBF';
        case HairColorName_1.default.Red:
            return '#C93305';
        case HairColorName_1.default.SilverGray:
            return '#E8E1E1';
        case HairColorName_1.default.BrownDark:
        default:
            return '#4A312C';
    }
}
